module.exports = __webpack_public_path__ + "img/安卓下载.89a132eb.png";